@import '../../../globals/main.scss';

pn--marketweb-input {
  display: inline-flex;
  flex-direction: column;
}

pn-marketweb-input input {
  padding: 0.75em;
  font-size: 1em;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  outline: none;
  border-radius: 0.8rem;
  border: 0.1rem solid $gray700;
  transition:
    box-shadow 0.15s,
    border 0.15s;
  color: $black;
  width: 100%;

  &::placeholder {
    color: $gray400;
    font-weight: normal;
  }

  &:focus {
    border: 0.1rem solid $blue700;
    box-shadow:
      0 0 0 0.2rem #fff,
      0 0 0 0.4rem $blue700;
  }

  &:hover {
    border: 0.1rem solid $blue400;
  }

  &:disabled {
    background: $gray50;
    border: none;
  }
}

pn-marketweb-input > .input-container {
  position: relative;

  > button {
    position: absolute;
    right: 1.2rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: $blue700;
    padding: 0.6rem;
    border-radius: 0.8rem;
    outline: none;
    transition:
      border 0.1s,
      background 0.2s,
      color 0.1s;
    border: 0.1rem solid transparent;

    &:focus {
      border: 0.1rem solid $blue700;
    }

    &:hover {
      background: $blue50;
    }

    &:active {
      background: $blue700;
      color: white;
    }
  }

  > svg {
    position: absolute;
    right: 0.75em;
    top: 50%;
    transform: translateY(-50%);
    height: 1.5em;
    width: 1.5em;
    pointer-events: none;

    polyline {
      stroke-linecap: round;
      transition: stroke-dashoffset 0.2s cubic-bezier(0.79, 0.14, 0.15, 0.86);
    }
  }

  > svg.pn-input-checkmark polyline {
    stroke: $green700;
    stroke-dashoffset: 23;
    stroke-dasharray: 23;
  }
}

pn-marketweb-input .label-container {
  margin-bottom: 0.4rem;
  color: $gray700;
  font-size: 0.875em;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  label {
    cursor: pointer;
    transition: color 0.2s;
  }
}

.label-container label.char-count {
  flex-shrink: 0;
  padding-left: 0.5em;
}

pn-marketweb-input small {
  font-size: 0.75em;
  font-size: unquote('max(.6em, 1.2rem)');
  transition: transform 0.2s cubic-bezier(0.79, 0.14, 0.15, 0.86);
  margin-top: 0.5em;
  color: $gray700;
}

pn-input.error {
  color: $warning;

  label {
    color: $warning;
  }

  small {
    color: $warning;
  }

  small > pn-icon {
    margin-right: 0.25em;
  }

  input {
    border: 0.1rem solid $warning;

    &:focus {
      border: 0.1rem solid $warning;
      box-shadow:
        0 0 0 0.2rem #fff,
        0 0 0 0.4rem $warning;
    }

    &:hover {
      border: 0.1rem solid $coral400;
    }
  }
}

pn-input.valid {
  color: $green700;

  .input-container > svg.pn-input-checkmark polyline {
    stroke-dashoffset: 0;
  }

  label {
    color: $green700;
  }

  input {
    border: 0.1rem solid $green700;

    &:focus {
      border: 0.1rem solid $green700;
      box-shadow:
        0 0 0 0.2rem #fff,
        0 0 0 0.4rem $green700;
    }

    &:hover {
      border: 0.1rem solid $green400;
    }
  }
}

pn-marketweb-input.password input {
  padding-right: 4em;
}

pn-marketweb-input.icon input {
  padding-right: 2.3em;
}
